import api from './api';

export const radioInfoService = {
  getActiveRadioInfo: () => api.get('/radio-info/active'),
  getAllRadioInfo: () => api.get('/radio-info'),
  getRadioInfoById: (id) => api.get(`/radio-info/${id}`),
  createRadioInfo: (data) => api.post('/radio-info', data),
  updateRadioInfo: (id, data) => api.put(`/radio-info/${id}`, data),
  deleteRadioInfo: (id) => api.delete(`/radio-info/${id}`),
  setActiveRadioInfo: (id) => api.put(`/radio-info/${id}/activate`),
  toggleChat: (data = {}) => api.put('/radio-info/toggle-chat', data),
};
